import { TaInput } from '@components/shared';
import { useTranslation } from 'react-i18next';

export const Company = ({ getFieldProps, touched, errors }: any) => {
	const { t } = useTranslation();

	return (
		<form className="flex flex-col xs:mt-0 h-full gap-[20px]">
			<TaInput
				id="company_name"
				label={t('companyName')}
				size="small"
				required
				{...getFieldProps('company_name')}
				error={touched.company_name && errors.company_name}
				touched={touched.company_name}
			/>
			<TaInput
				id="company_id_number"
				label={t('companyIdNumber')}
				size="small"
				type="text"
				required
				{...getFieldProps('company_id_number')}
				error={touched.company_id_number && errors.company_id_number}
				touched={touched.company_id_number}
			/>
			<TaInput
				id="representative_first_name"
				label={t('findSpecialistPage.monitoring.repFirstName')}
				size="small"
				required
				{...getFieldProps('representative_first_name')}
				error={touched.representative_first_name && errors.representative_first_name}
				touched={touched.representative_first_name}
			/>
			<TaInput
				id="representative_last_name"
				label={t('findSpecialistPage.monitoring.repLastName')}
				{...getFieldProps('representative_last_name')}
				size="small"
				required
				error={touched.representative_last_name && errors.representative_last_name}
				touched={touched.representative_last_name}
			/>
			{/* Email field removed - will be taken from JWT token */}
			<TaInput
				id="mobile_number"
				label={t('mobileNumber')}
				{...getFieldProps('mobile_number')}
				size="small"
				onKeyPress={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
				type="number"
				required
				error={touched.mobile_number && errors.mobile_number}
				touched={touched.mobile_number}
			/>
		</form>
	);
};
